import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { APIUrl } from '../../app-service-routing';
import { AdminPanelService } from '../../services/admin-panel.service';
import { Validators, FormBuilder, FormGroup, FormControl, FormArray } from '@angular/forms';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-product-functinalites',
  templateUrl: './product-functinalites.component.html',
  styleUrls: ['./product-functinalites.component.scss']
})

export class ProductFunctinalitesComponent implements OnInit {
  productForm: FormGroup;
  editForm: FormGroup;
  respinse;
  edit_product_list: boolean = true;
  add_product_list: boolean = true;
  list_product_list: boolean = false;
  list_data_product: any;
  list_data_category: any;
  displayedColumns: string[] = ['logo', 'productName', 'Range', 'enable', 'Action'];
  dataSource;
  selectedValue = '2776d3e4-3e92-48cd-86f9-dee02917cf8e';
  myFormValueChanges$;
  selectedFile: any;
  public imagePath;
  imgURL: any;
  public message: string;

  constructor(private adminpanelservice: AdminPanelService, private formBuilder: FormBuilder, public router: Router) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.categorylisting();
    this.productlisting(this.selectedValue)
    this.createform();
    this.edit_form();
  }

  preview(event, data, index) {
    if (event.target.files.length === 0)
      return;
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    this.imagePath = event.target.files;
    this.selectedFile = event.target.files[0]
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
    const uploadData = new FormData();
    uploadData.append('myFile', this.selectedFile, this.selectedFile.name);
    this.adminpanelservice.imageupload(APIUrl.imageupload, uploadData).subscribe(response => {
      this.productForm.controls.Products['controls'][index].controls.ProductImage.value = response['message'];
      this.productForm.controls.Products['controls'][index].controls.imgurl.value = environment.imageUrl + '/' + response['message'];
    }, error => {
    });
  }

  createform() {
    this.productForm = this.formBuilder.group({
      Products: this.formBuilder.array([
        this.getUnit()
      ])
    });
    this.myFormValueChanges$ = this.productForm.controls['Products'].valueChanges;
  }

  ngOnDestroy(): void {
    this.myFormValueChanges$.unsubscribe();
  }

  /**
   * Save form data
   */
  save(model: any, isValid: boolean, e: any) {
    e.preventDefault();
    this.adminpanelservice.updateResultSet(APIUrl.addproductUrl, model).subscribe(response => {
      console.log(response);
      if (response['message']) {
        this.list_product();
        this.productlisting(this.selectedValue)
        this.createform();
      }
    }, error => {
    });
  }

  /**
   * Create form unit
   */
  private getUnit() {
    const numberPatern = '^[0-9.,]+$';
    return this.formBuilder.group({
      ProductImage: [''],
      imgurl: [''],
      CategoryID: ['', Validators.required],
      ProductName: ['', Validators.required],
      ProductDescription: ['', Validators.required],
      MinimumPrice: ['', [Validators.required, Validators.pattern(numberPatern)]],
      MaximumPrice: ['', [Validators.required, Validators.pattern(numberPatern)]],
    });
  }

  /**
   * Add new unit row into form
   */
  private addUnit() {
    const control = <FormArray>this.productForm.controls['Products'];
    control.push(this.getUnit());
  }

  /**
   * Remove unit row from form on click delete button
   */
  private removeUnit(i: number) {
    const control = <FormArray>this.productForm.controls['Products'];
    control.removeAt(i);
  }

  edit(model: any, isValid: boolean, e: any) {
    this.adminpanelservice.updateResultSet(APIUrl.editdeleteproduct, model).subscribe(response => {
      console.log(response);
      if (response['message']) {
        this.list_product();
        this.productlisting(this.selectedValue)
        this.createform();
      }
    }, error => {
    });
  }


  edit_product(data) {
    debugger;
    this.list_product_list = true;
    this.add_product_list = true;
    this.edit_product_list = false;
    this.editForm.patchValue({
      productID: data.productID,
      action: "Edit",
      CategoryID: data.CategoryID,
      ProductImage: data.productLogoName_Small,
      imgurl: data.productLogoPath_Small,
      ProductName: data.productName,
      ProductDescription: data.productDescription,
      MinimumPrice: data.minimumPrice,
      MaximumPrice: data.minimumPrice,
      isActive: data.isActive
    });
  }

  edit_form() {
    this.editForm = new FormGroup({
      CategoryID: new FormControl(),
    });
    const numberPatern = '^[0-9.,]+$';
    this.editForm = this.formBuilder.group({
      ProductImage: [''],
      imgurl: [''],
      productID: [''],
      action: "Edit",
      CategoryID: ['', Validators.required],
      ProductName: ['', Validators.required],
      ProductDescription: ['', Validators.required],
      MinimumPrice: ['', [Validators.required, Validators.pattern(numberPatern)]],
      MaximumPrice: ['', [Validators.required, Validators.pattern(numberPatern)]],
    });
  }


  edit_imageupload(event) {
    if (event.target.files.length === 0)
      return;
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    this.imagePath = event.target.files;
    this.selectedFile = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
    const uploadData = new FormData();
    uploadData.append('myFile', this.selectedFile, this.selectedFile.name);
    this.adminpanelservice.imageupload(APIUrl.imageupload, uploadData).subscribe(response => {
      this.editForm.controls['ProductImage'].setValue(this.selectedFile ? this.selectedFile.name : '');
      this.editForm.patchValue({
        ProductImage: response['message'],
        imgurl: environment.imageUrl + '/' + response['message'],
      });
    }, error => {
    });
  }
  // GET APIS For binding
  productlisting(selected) {
    this.adminpanelservice.getReseultSetList(APIUrl.allproduct + selected).subscribe(response => {
      this.list_data_product = response;

      this.dataSource = new MatTableDataSource<PeriodicElement>(this.list_data_product);
      this.dataSource.paginator = this.paginator;
    }, error => {
    });
  }
  categorylisting() {
    this.adminpanelservice.getReseultSetList(APIUrl.categoryUrl).subscribe(response => {
      this.list_data_category = response
    }, error => {
    });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  // Add_product
  add_product() {
    this.edit_product_list = true;
    this.list_product_list = true;
    this.add_product_list = false;
  }
  //List_product
  list_product() {
    this.edit_product_list = true;
    this.add_product_list = true;
    this.list_product_list = false;
  }
  // Code ending
}

// Sample data
export interface PeriodicElement {
  logo: string;
  productName: string;
  Range: string;
  enable: string;
  Action: string;
}
